import { Component, Inject } from "@angular/core";
import { UntypedFormBuilder,  Validators } from "@angular/forms";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { Select, Store } from "@ngxs/store";
import { PatientEntity, SaveFamily, Provider, ServiceLevel, FamilyEntity, FamilyPatient, PatientPage, GetPractitionerGroups, GetFamilyById } from "huddyapi";
import { GetPatientById, GetPageOfPatients,GetServiceLevels,ClearPatientSearchList, GetProviderSettings, CompassState, ProviderSetting, PatientTag, PractitionerGroupStateModel, CompassStateModel, PractitionerGroupEntity} from "huddyapi";
import { Observable, of, Subscription } from "rxjs";
import { catchError } from "rxjs/operators";
import { DesktopErrorHandler } from "../../services/errorHandler.service";
import { EditPatientDialog } from "../edit-patient-dialog/edit-patient-dialog.component";
import { CommunityConfigService } from "../../services/community-config.service";


@Component({
  selector: 'edit-family-dialog',
  templateUrl: 'edit-family-dialog.component.html',
  styleUrls: ["./edit-family-dialog.component.scss"]
})
export class EditFamilyDialog  {
  
  providerSubscription: Subscription;
  @Select(state => state.compassState.providers) providers$: Observable<Provider[]>;
  @Select(state => state.familyState.currentFamily) families$: Observable<FamilyEntity>;
  @Select(state => state.patientState.currentPage) patients$: Observable<PatientPage>;
  @Select(state => state.practitionerGroupState) practitionerGroupState$: Observable<PractitionerGroupStateModel>;
  @Select(state => state.compassState) compassState$: Observable<CompassStateModel>;
  

  practitionerGroupSubscription : Subscription;
  compassStateSubscription : Subscription;
  groups : PractitionerGroupEntity[];
  serviceLevels : ServiceLevel[];
  panel = 0;
  
  patientSubscription: Subscription;
  provider : Provider;
  providers: Provider[];
  edited : FamilyEntity;
  addedPatient : FamilyPatient;
  familySubscription: Subscription;
  statuses : string[] = ['RECRUITED', 'ONBOARDED', 'COMPLETE'];
  patients : FamilyPatient[] = []; //search results
  familyPatients : FamilyPatient[] = [];
  familyRelationships : string[] = ['Primary', 'Spouse', 'Child', 'Parent', 'Unrelated resident', 'Relation', 'Friend'];
  fromFamilyPatient : boolean = false;
  useRandomServiceLevelAssignment : boolean;

  familyForm = this.formBuilder.group({
    identifier:  [''],
    familyRelationship: [''],
    status: ['', Validators.required],
    tags : [''],
    notes: [''],
    teams : [[]],
    serviceLevel : [''],
    search : ['']

});

  constructor(
    public dialogRef: MatDialogRef<EditFamilyDialog>,
    @Inject(MAT_DIALOG_DATA) public data: EditFamilyInput,
    private dialog : MatDialog,
    private formBuilder : UntypedFormBuilder,
    public store : Store,
    public errorHandler: DesktopErrorHandler
  )
  {
    this.edited = undefined;
    this.fromFamilyPatient = data.fromFamilyPatient;
    this.familyForm.reset();
    this.setFamily(data.family, 0);
 
  }

  ngOnInit(): void {
  //   this.familyForm.get('teams')!.valueChanges.subscribe(data => {
  //     console.log('Form changes', data);
  // })
    this.familySubscription = this.families$.subscribe((currentFamily: FamilyEntity) => {
        if (currentFamily) {
         this.setFamily(currentFamily, 1);
        }
        // console.log( 'EditFamilyDialog', 'currentFamily', this.edited);      
    });
    this.patientSubscription = this.patients$.subscribe((patientPage: PatientPage) => {
      // console.log('Edit Family', 'patientPage', patientPage);
      this.patients = [];
      if (this.addedPatient) {
        this.patients.push(this.addedPatient);
      }
      if (patientPage && patientPage.content) {


        this.patients = patientPage?.content.map(patient => ({
          familyIdentifier : this.familyForm.value.identifier,
          familyId : this.edited.id,
          description :   patient.identifier + ' ' + patient.friendlyName,
          relationship: 'Primary',
          status:  'NOT_CONSENTED',
          providerId : this.provider ? this.provider.id : undefined,
          patientId : patient.id,
        }));
       console.log('Edit Family', 'patientPage', this.patients);
      }
    });
    this.  compassStateSubscription  = this.compassState$.subscribe((compassState: CompassStateModel) => {
      if (compassState && compassState.serviceLevels ) {
         this.serviceLevels = [].concat(compassState.serviceLevels);
         this.checkRandomSLAssignment();
      }
      console.log('compassState', compassState);
      if (compassState && compassState.providerSettings ) {
        let randomAssignmentSetting : ProviderSetting = compassState.providerSettings.find(s => s.name === CompassState.SETTING_ASSIGN_SERVICE_LEVELS_RANDOM);
        this.useRandomServiceLevelAssignment =  (randomAssignmentSetting && randomAssignmentSetting.value === 'true') ? true : false;
        if (this.useRandomServiceLevelAssignment) {
          this.checkRandomSLAssignment();
        }
      }
    });
    this.providerSubscription = this.providers$.subscribe((providers: Provider[]) => {
      this.providers = providers;
      this.determineProvider();
    });
    this.  practitionerGroupSubscription  = this.practitionerGroupState$.subscribe((practitionerGroupState: PractitionerGroupStateModel) => {
      if (practitionerGroupState && practitionerGroupState.groups && practitionerGroupState.groups.length > 0) {
         this.groups = [].concat(practitionerGroupState.groups
          .filter(g => g.groupUsers.filter(gu => gu.role === 'EVALUATOR').length == 0)
         );
         if (this.edited.practitionerGroups && this.edited.practitionerGroups.length > 0 && this.edited.practitionerGroups[0]) {
          console.log('this.edited', this.edited);
        
          let current : PractitionerGroupEntity[] = this.groups
            .filter(g => this.edited.practitionerGroups.find(pg => pg.id === g.id));
            console.log('Setting groups to ' , current);
            this.familyForm.controls.teams.setValue(current); 
         }

      
      }
    });
  }


  familyDescription(relationship : string, identifier: string, namedPrimary: string, primaryAddress: string): string {
    return [relationship, identifier, namedPrimary, primaryAddress].join(' ');
  }

  getProviderDependentLists() {
    this.store.dispatch(new GetServiceLevels(this.provider.id));
    this.store.dispatch(new GetProviderSettings(this.provider.id));
    this.store.dispatch(new GetPractitionerGroups(this.provider.id, 'yes'));
  }

  determineProvider() {
    if (this.providers.length === 1) {
      this.provider = this.providers[0];
      this.getProviderDependentLists();
    } else if (this.familyPatients && this.familyPatients.length > 0) {
      let providerId = this.familyPatients[0].providerId;
      this.provider = this.providers.find(p => p.id == providerId);
      this.getProviderDependentLists();
    }
    
  }

  getFamilyRelationships() {
    const filtered : FamilyPatient[] = this.familyPatients.filter(fp => fp.relationship === 'PRIMARY');
    return filtered.length === 0 ? this.familyRelationships : this.familyRelationships.filter(r => r != 'Primary');
  }


  setFamily(data : FamilyEntity, context: number) {
    let teams  : PractitionerGroupEntity[] = [];
    this.patients = [];
    let serviceLevel : ServiceLevel = null;
    console.log('setFamily', data, context);
    if (data) {
      teams = (data.practitionerGroups) ? data.practitionerGroups : [];
      serviceLevel = this.resolveServiceLevel();
    }
    
    this.familyForm.setValue({
      identifier: data.identifier ?? '', 
      familyRelationship: null,
      tags: data.tags ?? '',
      notes: data.notes ?? '',
      status: data.status  ?? 'RECRUITED',
      search : '',
      teams : teams ,
      serviceLevel : serviceLevel
    });
    this.edited = {
      id : data.id,
      identifier: data.identifier ?? '',
      status : data.status ?? 'RECRUITED',
      hasLateAppointments: data.hasLateAppointments ?? undefined,
      patients: data.patients ? data.patients.map(patient => ({
          familyIdentifier : data.identifier,
          familyId : data.id,
          description :   patient.patient.identifier + ' ' + this.getFriendlyName(patient.patient),
          relationship:  patient.relationship,
          notes : patient.notes,
          patientId : patient.patientId,
          providerId: patient.providerId,
          status: patient.status
        })) : [],
        serviceLevelId : data.serviceLevelId,
        practitionerGroups : [].concat(data.practitionerGroups)
    };
    this.familyPatients = [].concat(this.edited.patients);
    // console.log('edited=', this.edited, this.familyPatients);

    if (this.useRandomServiceLevelAssignment) {
      this.familyForm.controls.serviceLevel.disable();
    }
    console.log('DATA.TAGS', data, data.tags);
    let patientArr : FamilyPatient[] = data.patients
    .filter(fr => fr.relationship === 'PRIMARY');
    if (data.tags || (patientArr.length > 0 && patientArr[0].patient?.tags)) {
      let tags : string = data.tags ? 
        data.tags.filter(t => t.tagEntity === 'FAMILY').map(t => t.text).join(',') :
        patientArr[0].patient.tags.filter(t => t.tagEntity === 'FAMILY').map(t => t.text).join(',');
      console.log('tags', tags);
      this.familyForm.controls.tags.setValue(tags);
      this.edited.tags = data.tags;
    }
    if (data.notes) {
      this.familyForm.controls.notes.setValue(data.notes);
    }
  }



  isFormInValid() {
    if (this.familyPatients.length === 0) {
      // console.log('isFormInvalid - family patients len = 0', this.familyPatients);
      return true;
    }
    let status : string = this.familyForm.value.status;
    const teams : any[] = this.familyForm.value.teams;
    if ((status === 'ONBOARDED') && (!teams || teams.length == 0)) {
      // console.log('isFormInvalid - ONBOARDED with no teams', status, teams);
      return true;
    }
    let primary : FamilyPatient = this.familyPatients.find(fp => fp.relationship === 'PRIMARY');
    if (!primary) {
      // console.log('isFormInvalid - no PRIMARY', this.familyPatients, primary);
      return true;
    }
    // console.log('isFormInvalid - form is valid');
    return false;
  }

  onSubmitForm(familyForm) {
    if (!this.isFormInValid())
      this.save();
  }

  close() {
      this.dialogRef.close();
  }

  checkRandomSLAssignment() {
    if (!this.familyForm.value.serviceLevel && this.serviceLevels && this.serviceLevels.length > 0 && this.useRandomServiceLevelAssignment && (!this.edited.serviceLevelId || this.edited.serviceLevelId === 0) ) {
      const max: number = this.serviceLevels.length;
      const r : number =  Math.floor(Math.random() * max);
      this.familyForm.controls.serviceLevel.setValue(this.serviceLevels[r]);
    
    } else if (this.edited.serviceLevelId && this.edited.serviceLevelId > 0) {
      this.familyForm.controls.serviceLevel.setValue(this.resolveServiceLevel());
    }
    if (this.useRandomServiceLevelAssignment) {
      this.familyForm.controls.serviceLevel.disable();
    }
    console.log('userrandservicelevelassignement', this.useRandomServiceLevelAssignment);
  }



  resolveServiceLevel() {
    return this.edited && this.edited.serviceLevelId && this.serviceLevels ? this.serviceLevels.find(sl => sl.id === this.edited.serviceLevelId) : null
  }

  save() {
      console.log('in save', this.familyForm.value.identifier, this.patients);

      this.edited.identifier =  this.familyForm.value.identifier;
      this.edited.status = this.familyForm.value.status;
      if (this.familyForm.value.serviceLevel) {
        this.edited.serviceLevelId = this.familyForm.value.serviceLevel.id;
      }

      if (this.familyForm.value.teams) {
        let practitionerGroups = [].concat( this.familyForm.value.teams);
        this.edited.practitionerGroups = [].concat(practitionerGroups); 
      }


      
      let tags : PatientTag[] = (this.edited.tags) ? this.edited.tags.filter(t => t.tagEntity != 'FAMILY') : [];
      let editedTags : string = this.familyForm.value.tags;
      let primary : FamilyPatient = this.familyPatients.find(p => p.relationship === 'PRIMARY');
      if (editedTags && editedTags.trim() != '') {

        tags = tags.concat(editedTags.trim().split(',').map(s => ({
          tagEntity : 'FAMILY',
          text : s,
          patientId : primary.patientId,
          entityId : this.edited.id
        })));
      }
      this.edited.tags = tags; 
      this.edited.notes = this.familyForm.value.notes;
      this.edited.patients = [].concat(this.familyPatients.map(p => {
        p.relationship = p.relationship.replace(' ', '_');
        p.providerId = this.provider.id;
        return p;
      }));
      console.log('SAVING FAMILY', this.edited,  tags);

      this.store.dispatch(new SaveFamily(this.edited))
      .pipe(
        catchError(err => {
          console.log('ERROR!!!!!', err.error);
          this.errorHandler.handle(err.error);
          return of ('');
        })
      )
      .subscribe(t => {
        if (this.edited.id) {
          this.store.dispatch(new GetFamilyById(this.edited.id))
          .subscribe(t => console.log('retrieved'));
        }
        this.close();
      });
    }
      
  
    getPageOfPatients(e) {
      this.patients = [];
      this.store.dispatch(new ClearPatientSearchList());
      const search : string = this.familyForm.value.search + e.key;
      //console.log('getPageOfPatients', search, e.key);
      if (search && search.length >  2 && !this.addedPatient) {
        this.store.dispatch(new GetPageOfPatients(0, 50, '', search, 'friendlyName', 'asc'))
      }
      if (this.addedPatient) {
        this.addedPatient = undefined;
      }
   }

   getSelectedPatient() {
    let candidateDescription : string = this.familyForm.value.search;
    if (candidateDescription && candidateDescription.length > 0) {
      let filtered : FamilyPatient[] = this.patients.filter(p => p.description === candidateDescription);
      if (filtered.length > 0) {
        return filtered[0];
      }
    }
    return undefined;
   }


  validPatientSelected() {
    let candidate : FamilyPatient = this.getSelectedPatient();
    let candidateRelationship : string = this.familyForm.value.familyRelationship;
    if (candidate && candidateRelationship && candidateRelationship.length > 0) {
      candidate.relationship = candidateRelationship.toUpperCase();
      const found : FamilyPatient = this.familyPatients.find(fp => fp.patientId === candidate.patientId);
      if (!found) {
        return candidate;
      }
    }
    return undefined;
  }

  addPatient() {
    let candidate : FamilyPatient = this.validPatientSelected();
    if (candidate) {
      this.addedPatient = undefined;
      this.familyPatients.push(candidate);
      this.familyForm.controls.search.setValue('');
      this.familyForm.controls.familyRelationship.setValue('');
      console.log('Added patient : ' , this.familyPatients);
    } else {
      let patientDialogRef = this.dialog.open(EditPatientDialog, {
        width: '600px',
        height: '575px',
        data: {
          patient: {},
          fromFamily: true
        }
      });
      patientDialogRef.afterClosed().subscribe(patient => {
        // console.log('addPatient', patient);
        let friendlyName =  this.getFriendlyName(patient);
        let familyPatient : FamilyPatient = {
          patientId : patient.id,
          familyIdentifier : this.familyForm.value.identifier,
          familyId : this.edited.id,
          description :   patient.identifier + ' ' + friendlyName,
          providerId: this.provider.id,
          relationship: '',
          status: 'NOT_CONSENTED'
        }
        this.patients.push(familyPatient);
        this.addedPatient = familyPatient;
        this.familyForm.controls.search.setValue(familyPatient.description);
        // console.log('addPatient', this.patients);
      });

    }
  }
  onRemovePatientFamily(patientId : number) {
    
    let idx : number = this.familyPatients
    .findIndex((fp : FamilyPatient) => (fp.patientId === patientId));
    // console.log('onRemovePatientFamily', patientId, this.familyPatients, idx);
    if (idx > -1)
      this.familyPatients.splice(idx, 1);
  }

  getFriendlyName(patient : PatientEntity) : string {
    let ret : string = patient.firstName ? patient.firstName + ' ' : '';
    if (patient.lastName)
      ret = ret + patient.lastName;
    return ret;
  }

  getServiceLevelNames() {
    let ret : string[] = [''];
    if (this.serviceLevels) {
      ret = ret.concat(this.serviceLevels.map(sl => sl.name));
    }
    return ret;
  }
  
  getPractitionerGroupNames() : string[] {
    let ret : string[] = [];
    // let existing : string[]= ( this.edited && this.edited.practitionerGroups) ? 
    //   this.edited.practitionerGroups
    //   .filter(g => g != null)
    //   .map(g => g.name) : [''];
    // if (existing.length === 0) {
    //   existing = [];
    // }  

    if (this.groups) {
      ret = ret.concat(this.groups.map(g => g.name));
    }

    return ret;
  }

  getServiceLevelForName(name : string) : ServiceLevel{
    let ret : ServiceLevel;
    if (this.serviceLevels) {
      ret = this.serviceLevels.find(sl => sl.name === name);
    }
    return ret;
  }
  

}

export interface EditFamilyInput {
  family : FamilyEntity;
  fromFamilyPatient: boolean;
}